<nav
  id="navbar-main"
  (click)="clickit()"
  class="navbar navbar-main navbar-expand-lg navbar-transparent navbar-light headroom headroom--top headroom--pinned"
>
  <div class="container">
    <a class="navbar-brand mr-lg-5" [routerLink]="['/']">
      <!-- LOGO MAIN  DESKTOP-->
      <img src="../../../../assets/img/brand/eduvita_white.svg" />
    </a>

    <a class="navbar-toggler tel_mob ml-auto" href="tel:+919111240646">
      <i class="fa fa-phone"></i>
    </a>
    <button
      class="navbar-toggler"
      type="button"
      (click)="isCollapsed = !isCollapsed"
      [attr.aria-expanded]="!isCollapsed"
      aria-controls="navbar_global"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div
      class="navbar-collapse collapse"
      id="navbar_global"
      [ngbCollapse]="isCollapsed"
    >
      <div class="navbar-collapse-header">
        <div class="row">
          <div class="col-6 collapse-brand">
            <a [routerLink]="['/home']">
              <img src="../../../../assets/img/brand/eduvita_blue.svg" />
            </a>
          </div>
          <div class="col-6 collapse-close">
            <button
              type="button"
              class="navbar-toggler"
              (click)="isCollapsed = !isCollapsed"
              [attr.aria-expanded]="!isCollapsed"
              aria-controls="navbar_global"
            >
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
      <ul class="navbar-nav navbar-nav-hover align-items-lg-center ml-lg-auto">
        <li class="nav-item">
          <a
            [routerLink]="['/']"
            class="nav-link"
            data-toggle="tooltip"
            role="button"
          >
            <i class="fa fa-home text-purple d-lg-none"></i>
            <span class="nav-link-inner--text">Home</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon login"
            [routerLink]="['/products']"
            data-toggle="tooltip"
          >
            <i class="ni ni-cart text-info d-lg-none"></i>
            <span class="nav-link-inner--text">Products</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon login"
            [routerLink]="['/services']"
            data-toggle="tooltip"
          >
            <i class="ni ni-diamond text-red d-lg-none"></i>
            <span class="nav-link-inner--text">Services</span>
          </a>
        </li>
        <!-- <li class="nav-item">
          <a
            class="nav-link nav-link-icon login"
            [routerLink]="['/packages']"
            data-toggle="tooltip"
          >
            <i class="ni ni-money-coins text-indigo d-lg-none"></i>
            <span class="nav-link-inner--text">Packages</span>
          </a>
        </li> -->
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon login"
            [routerLink]="['/about']"
            data-toggle="tooltip"
          >
            <i class="ni ni-tie-bow text-info d-lg-none"></i>
            <span class="nav-link-inner--text">About</span>
          </a>
        </li>
        <!--
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon login"
            [routerLink]="['/auth/signin']"
            data-toggle="tooltip"
          >
            <i class="material-icons">fingerprint</i>
            <span class="nav-link-inner--text d-lg-none">Login</span>
          </a>
        </li> -->
      </ul>
    </div>
  </div>
</nav>
